module.exports = __webpack_public_path__ + "06dd12d7f560f3f2347b2b929ac13e54.svg";